var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AbilityTraining"},[_c('ul',[_c('li',[_c('img',{attrs:{"src":require("../assets/AbilityTraining/one.jpg"),"alt":""}})]),_c('li',[_c('img',{attrs:{"src":require("../assets/AbilityTraining/two.jpg"),"alt":""}})]),_c('li',[_c('img',{attrs:{"src":require("../assets/AbilityTraining/three.jpg"),"alt":""}})])])])
}]

export { render, staticRenderFns }